import {
  ChatMessageRequest,
  ChatResponse,
  ChatSession,
  ChatSessionDetail,
  CreateSessionRequest,
} from "@/types/chat";
import { fetchWithAuth } from "./client";

export const chatApi = {
  sendMessage: async (request: ChatMessageRequest): Promise<ChatResponse> => {
    return fetchWithAuth("/api/v1/ai/chat", {
      method: "POST",
      body: JSON.stringify(request),
    });
  },

  createSession: async (request: CreateSessionRequest): Promise<ChatSession> => {
    return fetchWithAuth("/api/v1/ai/chat/sessions", {
      method: "POST",
      body: JSON.stringify(request),
    });
  },

  listSessions: async (licitacion_id?: string, limit: number = 20): Promise<{ sessions: ChatSession[]; total: number }> => {
    const params = new URLSearchParams();
    if (licitacion_id) params.append("licitacion_id", licitacion_id);
    params.append("limit", limit.toString());

    return fetchWithAuth(`/api/v1/ai/chat/sessions?${params.toString()}`);
  },

  getSession: async (sessionId: string): Promise<ChatSessionDetail> => {
    return fetchWithAuth(`/api/v1/ai/chat/sessions/${sessionId}`);
  },

  deleteSession: async (sessionId: string): Promise<void> => {
    return fetchWithAuth(`/api/v1/ai/chat/sessions/${sessionId}`, {
      method: "DELETE",
    });
  },
};
